// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".property-name[data-v-8a7978fa]{font-size:14px !important;font-weight:bold}", ""]);
// Exports
module.exports = exports;
